<template>
    <div class="autocomplete-v2">
        <b-form-group>
            <label :for="`input-${id}`" v-if="!!label">{{ label }}</label>
            <b-form-input
                :id="`input-${id}`"
                v-model="search"
                @input="onInput"
                @keyup.down="onDown"
                @keyup.up="onUp"
                @keyup.enter="selectItem"
                :ref="id"
            ></b-form-input>
        </b-form-group>
        <div v-if="showResults" class="autocomplete-results">
            <ul>
                <li
                    v-for="(result, idx) in results"
                    class="autocomplete-result-item"
                    :class="isActive(idx) ? 'autocomplete-active' : ''"
                    @mouseover="index = idx"
                    @click="onItemClick(idx)"
                    :key="idx"
                >
                    {{ !!formater ? formater(result) : result[fieldLabel] }}
                </li>
            </ul>
        </div>
        <span v-if="busy" class="autocomplete-loader">Buscando...</span>
    </div>
</template>
<script>
export default {
    props: {
        label: {
            type: String,
            default: '',
        },
        id: {
            type: String,
            default: () => `${parseInt(Math.random() * 100000000)}`,
        },
        resource: {
            type: String,
            default: '',
        },
        formater: {
            type: Function,
            default: null,
        },
        minLenght: {
            type: [String, Number],
            default: 3,
        },
        searchAuto: {
            type: Boolean,
            default: true,
        },
        params: {
            type: Object,
            default: null,
        },
        fieldValue: {
            type: String,
            default: 'id',
        },
        fieldLabel: {
            type: String,
            default: 'name',
        },
        searchedValue: {
            type: String,
            default: '',
        },
    },
    data: () => ({
        search: '',
        open: false,
        results: [],
        index: -1,
        delay: null,
        busy: false,
    }),
    watch: {
        search(val) {
            if (!!val) return

            this.search = ''
            this.results = []
        },
        searchedValue(val) {
            if (!!val) this.search = val
            //this.results = []
        },
    },
    computed: {
        hasResults() {
            return this.results.length > 0
        },
        showResults() {
            return !!this.open && this.hasResults
        },
    },
    methods: {
        onInput() {
            clearTimeout(this.delay)
            this.results = []
            if (!this.searchAuto) return

            if (this.search.length < this.minLenght) return

            this.open = true

            this.delay = setTimeout(async () => {
                const params = { ...this.params, search: this.search }
                try {
                    this.busy = true
                    const { data } = await this.$repo.get(this.resource, params)
                    this.results = data
                } catch (error) {
                    toastr.error(error)
                } finally {
                    this.busy = false
                }
            }, 500)
        },
        onDown() {
            this.index = Math.min(this.results.length - 1, this.index + 1)
        },
        onUp() {
            this.index = Math.max(0, this.index - 1)
        },
        isActive(idx) {
            return this.index === idx
        },
        selectItem() {
            if (this.index < 0 || this.index >= this.results.length) return

            const selected = this.results[this.index]

            this.search = !!this.formater ? this.formater(selected) : selected

            this.$emit('input', selected)

            this.results = []

            this.open = false
        },
        onItemClick(idx) {
            this.index = idx
            this.selectItem()
        },
        clear() {
            this.results = []
            this.search = ''
            this.$refs[this.id].focus()
        },
    },
}
</script>
<style scoped>
.autocomplete-results ul {
    padding: 5px;
}
.autocomplete-results {
    position: absolute;
    top: 68px;
    left: 12px;
    z-index: 99;
    width: 95%;
    background-color: white;
    border: 1px solid lightgray;
    max-height: 300px;
    overflow: auto;
}
.autocomplete-result-item {
    list-style: none;
    padding: 5px;
    cursor: pointer;
    border-top: 1px dotted lightgray;
    padding-left: 0;
}
/* .autocomplete-result-item:hover {
    background-color: darkblue;
    color: white;
} */
.autocomplete-active {
    background-color: darkblue;
    color: white;
}
.autocomplete-loader {
    width: 95%;
    background-color: white;
    position: absolute;
    top: 68px;
    z-index: 999;
    color: darkblue;
}
</style>
